import FeaturedVideo from './FeaturedVideo'

export default FeaturedVideo;